// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBj0l3HLsu24vsmm2NV3jbXE80Xiepc8IM",
  authDomain: "studydashboard-2e2da.firebaseapp.com",
  projectId: "studydashboard-2e2da",
  storageBucket: "studydashboard-2e2da.firebasestorage.app",
  messagingSenderId: "1029826825187",
  appId: "1:1029826825187:web:4d543288c07196f8326ed6",
  measurementId: "G-XSSP9E0NT3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);